import i18n from 'common/locales'

export function getEmailOptions() {
  return [
    {
      text: i18n.global.t('customVariables.email'),
      menu: [
        { text: 'Unsubscribe link', value: '{{email.unsubscribe_link}}' },
        { text: 'Preview in Browser', value: '{{email.view_in_browser_url}}' },
      ],
    },
  ]
}

export function getMembershipOptions() {
  return [
    {
      text: i18n.global.t('customVariables.email'),
      value: '{{membership_contact.email}}',
    },
    {
      text: i18n.global.t('customVariables.password'),
      value: '{{membership_contact.password}}',
    },
    {
      text: i18n.global.t('customVariables.loginUrl'),
      value: '{{membership_contact.login_url}}',
    },
    {
      text: i18n.global.t('customVariables.offerTitle'),
      value: '{{membership_contact.offer_title}}',
    },
    {
      text: i18n.global.t('customVariables.categoryUrl'),
      value: '{{membership_contact.category_url}}',
    },
    {
      text: i18n.global.t('customVariables.productTitle'),
      value: '{{membership_contact.product_title}}',
    },
    {
      text: i18n.global.t('customVariables.categoryTitle'),
      value: '{{membership_contact.category_title}}',
    },
    {
      text: i18n.global.t('customVariables.phone'),
      value: '{{membership_contact.support_email}}',
    },
    {
      text: i18n.global.t('customVariables.siteName'),
      value: '{{membership_contact.support_phone}}',
    },
    {
      text: i18n.global.t('customVariables.siteName'),
      value: '{{membership_contact.site_name}}',
    },
  ]
}
export function getShopifyOptions() {
  return [
    {
      text: i18n.global.t('customVariables.number'),
      value: '{{order.number}}',
    },
    {
      text: i18n.global.t('customVariables.createdOn'),
      value: '{{order.created_on}}',
    },
    {
      text: i18n.global.t('customVariables.createdOn'),
      menu: [
        {
          text: i18n.global.t('customVariables.firstName'),
          value: '{{order.customer.first_name}}',
        },
        {
          text: i18n.global.t('customVariables.lastName'),
          value: '{{order.customer.last_name}}',
        },
        {
          text: i18n.global.t('customVariables.email'),
          value: '{{order.customer.email}}',
        },
        {
          text: i18n.global.t('customVariables.phone'),
          value: '{{order.customer.phone}}',
        },
      ],
    },
    {
      text: i18n.global.t('customVariables.totalDiscounts'),
      value: '{{order.total_discounts}}',
    },
    {
      text: i18n.global.t('customVariables.discountCode'),
      value: '{{order.discount_code}}',
    },
    {
      text: i18n.global.t('customVariables.totalPrice'),
      value: '{{order.total_price}}',
    },
    {
      text: i18n.global.t('customVariables.subtotalPrice'),
      value: '{{order.subtotal_price}}',
    },
    {
      text: i18n.global.t('customVariables.totalShippingPrice'),
      value: '{{order.total_shipping_price}}',
    },
    {
      text: i18n.global.t('customVariables.totalCartPrice'),
      value: '{{order.total_cart_price}}',
    },
    {
      text: i18n.global.t('customVariables.orderStatusURL'),
      value: '{{order.order_status_url}}',
    },
    {
      text: i18n.global.t('customVariables.abandonedCheckoutURL'),
      value: '{{order.abandoned_checkout_url}}',
    },
    {
      text: i18n.global.t('customVariables.shippingAddress'),
      value: '{{order.shipping_address}}',
    },
    {
      text: i18n.global.t('customVariables.billingAddress'),
      value: '{{order.billing_address}}',
    },
    {
      text: i18n.global.t('customVariables.hasDiscount'),
      value: '{{order.has_discount}}',
    },
    {
      text: i18n.global.t('customVariables.currencyCode'),
      value: '{{order.currency_code}}',
    },
    {
      text: i18n.global.t('customVariables.currency'),
      value: '{{order.currency}}',
    },
    {
      text: i18n.global.t('customVariables.requiresShipping'),
      value: '{{order.requires_shipping}}',
    },
  ]
}
export function getAffiliateOptions() {
  return [
    {
      text: i18n.global.t('customVariables.fullName'),
      value: '{{affiliate.name}}',
    },
    {
      text: i18n.global.t('customVariables.firstName'),
      value: '{{affiliate.first_name}}',
    },
    {
      text: i18n.global.t('customVariables.lastName'),
      value: '{{affiliate.last_name}}',
    },
    {
      text: i18n.global.t('customVariables.email'),
      value: '{{affiliate.email}}',
    },
    {
      text: i18n.global.t('customVariables.campaignName'),
      value: '{{affiliate.campaign_name}}',
    },
    {
      text: i18n.global.t('customVariables.commissionValue'),
      value: '{{affiliate.commission}}',
    },
    {
      text: i18n.global.t('customVariables.affiliateLink'),
      value: '{{affiliate.link}}',
    },
    {
      text: i18n.global.t('customVariables.locationName'),
      value: '{{affiliate.location_name}}',
    },
    {
      text: i18n.global.t('customVariables.clientPortalAppUrl'),
      value: '{{affiliate.client_portal_url}}',
    },
  ]
}
export function getOrdersOptions() {
  return [
    {
      text: i18n.global.t('customVariables.source'),
      value: '{{order.source}}',
    },
    {
      text: i18n.global.t('customVariables.paymentGateway'),
      value: '{{order.payment_gateway}}',
    },
    {
      text: i18n.global.t('customVariables.createdOn'),
      value: '{{order.created_on}}',
    },

    {
      text: 'Customer',
      menu: [
        {
          text: i18n.global.t('customVariables.firstName'),
          value: '{{order.customer.first_name}}',
        },
        {
          text: i18n.global.t('customVariables.lastName'),
          value: '{{order.customer.last_name}}',
        },
        {
          text: i18n.global.t('common.name'),
          value: '{{order.customer.name}}',
        },
        {
          text: i18n.global.t('customVariables.email'),
          value: '{{order.customer.email}}',
        },
        {
          text: i18n.global.t('customVariables.phone'),
          value: '{{order.customer.phone}}',
        },
        {
          text: i18n.global.t('customVariables.fullAddress'),
          value: '{{order.customer.full_address}}',
        },
        {
          text: i18n.global.t('customVariables.city'),
          value: '{{order.customer.city}}',
        },
        {
          text: i18n.global.t('customVariables.state'),
          value: '{{order.customer.state}}',
        },
        {
          text: i18n.global.t('customVariables.postalCode'),
          value: '{{order.customer.postal_code}}',
        },
        {
          text: i18n.global.t('customVariables.country'),
          value: '{{order.customer.country}}',
        },
      ],
    },
    {
      text: i18n.global.t('customVariables.currencyCode'),
      value: '{{order.currency_code}}',
    },
    {
      text: i18n.global.t('customVariables.currencySymbol'),
      value: '{{order.currency_symbol}}',
    },
    {
      text: i18n.global.t('customVariables.totalCartPrice'),
      value: '{{order.total_cart_price}}',
    },
    {
      text: i18n.global.t('customVariables.hasDiscount'),
      value: '{{order.has_discount}}',
    },
    {
      text: i18n.global.t('customVariables.totalDiscounts'),
      value: '{{order.total_discount}}',
    },
    {
      text: i18n.global.t('customVariables.discountCode'),
      value: '{{order.discount_code}}',
    },
    {
      text: i18n.global.t('customVariables.totalPrice'),
      value: '{{order.total_price}}',
    },
  ]
}
export function getInvoiceOptions() {
  return [
    {
      text: i18n.global.t('customVariables.company'),
      menu: [
        {
          text: i18n.global.t('common.name'),
          value: '{{invoice.company.name}}',
        },
        {
          text: i18n.global.t('customVariables.phone'),
          value: '{{invoice.company.phone}}',
        },
        {
          text: i18n.global.t('customVariables.address'),
          value: '{{invoice.company.address}}',
        },
        {
          text: i18n.global.t('customVariables.city'),
          value: '{{invoice.company.city}}',
        },
        {
          text: i18n.global.t('customVariables.state'),
          value: '{{invoice.company.state}}',
        },
        {
          text: i18n.global.t('customVariables.country'),
          value: '{{invoice.company.country}}',
        },
        {
          text: i18n.global.t('customVariables.website'),
          value: '{{invoice.company.website}}',
        },
        {
          text: i18n.global.t('customVariables.logo'),
          value: '{{invoice.company.logo}}',
        },
      ],
    },
    {
      text: i18n.global.t('customVariables.customer'),
      menu: [
        {
          text: i18n.global.t('common.name'),
          value: '{{invoice.customer.name}}',
        },
        {
          text: i18n.global.t('customVariables.firstName'),
          value: '{{invoice.customer.first_name}}',
        },
        {
          text: i18n.global.t('customVariables.lastName'),
          value: '{{invoice.customer.last_name}}',
        },
        {
          text: i18n.global.t('customVariables.phone'),
          value: '{{invoice.customer.phone}}',
        },
        {
          text: i18n.global.t('customVariables.email'),
          value: '{{invoice.customer.email}}',
        },
        {
          text: i18n.global.t('customVariables.company'),
          value: '{{invoice.customer.company}}',
        },
        {
          text: i18n.global.t('customVariables.address'),
          value: '{{invoice.customer.address}}',
        },
        {
          text: i18n.global.t('customVariables.city'),
          value: '{{invoice.customer.city}}',
        },
        {
          text: i18n.global.t('customVariables.state'),
          value: '{{invoice.customer.state}}',
        },
        {
          text: i18n.global.t('customVariables.postalCode'),
          value: '{{invoice.customer.postal_code}}',
        },
      ],
    },
    {
      text: i18n.global.t('customVariables.sender'),
      menu: [
        {
          text: i18n.global.t('common.name'),
          value: '{{invoice.sender.name}}',
        },
        {
          text: i18n.global.t('customVariables.email'),
          value: '{{invoice.customer.email}}',
        },
      ],
    },
    {
      text: i18n.global.t('common.name'),
      value: '{{invoice.name}}',
    },
    {
      text: i18n.global.t('customVariables.number'),
      value: '{{invoice.number}}',
    },
    {
      text: i18n.global.t('customVariables.issueDate'),
      value: '{{invoice.issue_date}}',
    },
    {
      text: i18n.global.t('customVariables.dueDate'),
      value: '{{invoice.due_date}}',
    },
    {
      text: i18n.global.t('customVariables.subTotal'),
      value: '{{invoice.sub_total}}',
    },
    {
      text: 'Currency Code',
      value: '{{invoice.currency_code}}',
    },
    {
      text: 'Sub Total',
      value: '{{invoice.sub_total}}',
    },
    {
      text: i18n.global.t('customVariables.discountAmount'),
      value: '{{invoice.discount_amount}}',
    },
    {
      text: i18n.global.t('customVariables.taxAmount'),
      value: '{{invoice.tax_amount}}',
    },
    {
      text: i18n.global.t('customVariables.totalAmount'),
      value: '{{invoice.total_amount}}',
    },
    {
      text: i18n.global.t('common.title'),
      value: '{{invoice.title}}',
    },
    {
      text: i18n.global.t('common.url'),
      value: '{{invoice.url}}',
    },
    {
      text: i18n.global.t('customVariables.cardInformation'),
      menu: [
        {
          text: i18n.global.t('customVariables.cardBrand'),
          value: '{{invoice.card.brand}}',
        },
        {
          text: i18n.global.t('customVariables.last4'),
          value: '{{invoice.card.last4}}',
        },
      ],
    },
    {
      text: i18n.global.t('customVariables.amountDue'),
      value: '{{invoice.amount_due}}',
    },
    {
      text: i18n.global.t('customVariables.amountPaid'),
      value: '{{invoice.amount_paid}}',
    },
  ]
}
export function getTagOptions() {
  let userTagOption = {
    text: i18n.global.t('customVariables.user'),
    menu: [
      {
        text: i18n.global.t('customVariables.fullName'),
        value: '{{user.name}}',
      },
      {
        text: i18n.global.t('customVariables.firstName'),
        value: '{{user.first_name}}',
      },
      {
        text: i18n.global.t('customVariables.lastName'),
        value: '{{user.last_name}}',
      },
      {
        text: i18n.global.t('customVariables.email'),
        value: '{{user.email}}',
      },
      { text: i18n.global.t('customVariables.phone'), value: '{{user.phone}}' },
      {
        text: i18n.global.t('customVariables.signature'),
        value: '{{user.email_signature}}',
      },
      {
        text: i18n.global.t('customVariables.calendarLink'),
        value: '{{user.calendar_link}}',
      },
      {
        text: i18n.global.t('customVariables.twilioPhone'),
        value: '{{user.twilio_phone_number}}',
      },
    ],
  }

  let appointmentTagOption = {
    text: i18n.global.t('customVariables.appointment'),
    menu: [
      {
        text: i18n.global.t('customVariables.startDateTime'),
        value: '{{appointment.start_time}}',
      },
      {
        text: i18n.global.t('customVariables.startDate'),
        value: '{{appointment.only_start_date}}',
      },
      {
        text: i18n.global.t('customVariables.startTime'),
        value: '{{appointment.only_start_time}}',
      },
      {
        text: i18n.global.t('customVariables.endDateTime'),
        value: '{{appointment.end_time}}',
      },
      {
        text: i18n.global.t('customVariables.endDate'),
        value: '{{appointment.only_end_date}}',
      },
      {
        text: i18n.global.t('customVariables.timezone'),
        value: '{{appointment.timezone}}',
      },
      {
        text: i18n.global.t('customVariables.cancellationLink'),
        value: '{{appointment.cancellation_link}}',
      },
      {
        text: i18n.global.t('customVariables.rescheduleLink'),
        value: '{{appointment.reschedule_link}}',
      },
      {
        text: i18n.global.t('customVariables.meetingLocation'),
        value: '{{appointment.meeting_location}}',
      },
      {
        text: i18n.global.t('customVariables.notes'),
        value: '{{appointment.notes}}',
      },
      {
        text: i18n.global.t('customVariables.addToGoogleCalendar'),
        value: '{{appointment.add_to_google_calendar}}',
      },
      {
        text: i18n.global.t('customVariables.AddToOutlook'),
        value: '{{appointment.add_to_ical_outlook}}',
      },
    ],
  }
  // let appointmentUserTagOption = {
  //   text: 'User',
  //   menu: [
  //     { text: 'Full Name', value: '{{appointment.user.name}}' },
  //     { text: 'First Name', value: '{{appointment.user.first_name}}' },
  //     { text: 'Last Name', value: '{{appointment.user.last_name}}' },
  //     { text: 'Email', value: '{{appointment.user.email}}' },
  //     { text: 'Phone', value: '{{appointment.user.phone}}' },
  //     { text: 'Signature', value: '{{appointment.user.email_signature}}' },
  //     // { text: 'Calendar Link', value: '{{appointment.user.calendar_link}}' },
  //     {
  //       text: 'Twilio Phone',
  //       value: '{{appointment.user.twilio_phone_number}}',
  //     },
  //   ],
  // }
  // const currentLocation = vuex.getters['locations/getById'](
  //   router.currentRoute.params.location_id
  // )
  // let calendarOption
  // if (currentLocation && currentLocation.is_calendar_v3_on) {
  //   appointmentTagOption.menu.push(appointmentUserTagOption)
  //   calendarOption = {
  //     text: 'Calendar Service',
  //     menu: [{ text: 'Name', value: '{{calendarService.name}}' }],
  //   }
  // } else {
  //   calendarOption = {
  //     text: 'Calendar',
  //     menu: [{ text: 'Name', value: '{{calendar.name}}' }],
  //   }
  // }
  const tagOptions = [
    {
      text: i18n.global.t('customVariables.contact'),
      menu: [
        {
          text: i18n.global.t('customVariables.fullName'),
          value: '{{contact.name}}',
        },
        {
          text: i18n.global.t('customVariables.firstName'),
          value: '{{contact.first_name}}',
        },
        {
          text: i18n.global.t('customVariables.lastName'),
          value: '{{contact.last_name}}',
        },
        {
          text: i18n.global.t('customVariables.email'),
          value: '{{contact.email}}',
        },
        {
          text: i18n.global.t('customVariables.phone'),
          value: '{{contact.phone}}',
        },
        {
          text: i18n.global.t('customVariables.companyName'),
          value: '{{contact.company_name}}',
        },
        {
          text: i18n.global.t('customVariables.fullAddress'),
          value: '{{contact.full_address}}',
        },
        {
          text: i18n.global.t('customVariables.address1'),
          value: '{{contact.address1}}',
        },
        {
          text: i18n.global.t('customVariables.city'),
          value: '{{contact.city}}',
        },
        {
          text: i18n.global.t('customVariables.state'),
          value: '{{contact.state}}',
        },
        {
          text: i18n.global.t('customVariables.postalCode'),
          value: '{{contact.postal_code}}',
        },
        {
          text: i18n.global.t('customVariables.dateOfBirth'),
          value: '{{contact.date_of_birth}}',
        },
        {
          text: i18n.global.t('customVariables.source'),
          value: '{{contact.source}}',
        },
        {
          text: i18n.global.t('customVariables.website'),
          value: '{{contact.website}}',
        },
      ],
    },
    userTagOption,
    appointmentTagOption,
    // calendarOption,
    {
      text: i18n.global.t('customVariables.campaign'),
      menu: [
        {
          text: i18n.global.t('customVariables.eventDate&Time'),
          value: '{{campaign.event_date_time}}',
        },
        {
          text: i18n.global.t('customVariables.eventDate'),
          value: '{{campaign.event_date}}',
        },
        {
          text: i18n.global.t('customVariables.eventTime'),
          value: '{{campaign.event_time}}',
        },
      ],
    },
    {
      text: i18n.global.t('customVariables.message'),
      menu: [
        {
          text: i18n.global.t('customVariables.messageBody'),
          value: '{{message.body}}',
        },
      ],
    },
    {
      text: i18n.global.t('customVariables.account'),
      menu: [
        {
          text: i18n.global.t('common.name'),
          value: '{{location.name}}',
        },
        {
          text: i18n.global.t('customVariables.addressLine1'),
          value: '{{location.full_address}}',
        },
        {
          text: i18n.global.t('customVariables.addressLine1'),
          value: '{{location.address}}',
        },
        {
          text: i18n.global.t('customVariables.city'),
          value: '{{location.city}}',
        },
        {
          text: i18n.global.t('customVariables.state'),
          value: '{{location.state}}',
        },
        {
          text: i18n.global.t('customVariables.country'),
          value: '{{location.country}}',
        },
        {
          text: i18n.global.t('customVariables.postalCode'),
          value: '{{location.postal_code}}',
        },
        {
          text: i18n.global.t('customVariables.email'),
          value: '{{location.email}}',
        },
        {
          text: i18n.global.t('customVariables.phone'),
          value: '{{location.phone}}',
        },
        {
          text: i18n.global.t('customVariables.website'),
          value: '{{location.website}}',
        },
        {
          text: i18n.global.t('customVariables.owner'),
          value: '{{location.logo_url}}',
        },
        {
          text: i18n.global.t('customVariables.owner'),
          menu: [
            {
              text: i18n.global.t('customVariables.firstName'),
              value: '{{location_owner.first_name}}',
            },
            {
              text: i18n.global.t('customVariables.lastName'),
              value: '{{location_owner.last_name}}',
            },
            {
              text: i18n.global.t('customVariables.email'),
              value: '{{location_owner.email}}',
            },
          ],
        },
      ],
    },
    {
      text: i18n.global.t('customVariables.rightNow'),
      menu: [
        {
          text: i18n.global.t('customVariables.second'),
          value: '{{right_now.second}}',
        },
        {
          text: i18n.global.t('customVariables.minute'),
          value: '{{right_now.minute}}',
        },
        {
          text: i18n.global.t('customVariables.hour24hFormat'),
          value: '{{right_now.hour}}',
        },
        {
          text: i18n.global.t('customVariables.hourAMPMFormat'),
          value: '{{right_now.hour_ampm}}',
        },
        {
          text: i18n.global.t('customVariables.time24hFormat'),
          value: '{{right_now.time}}',
        },
        {
          text: i18n.global.t('customVariables.timeAMPMFormat'),
          value: '{{right_now.time_ampm}}',
        },
        {
          text: i18n.global.t('customVariables.AMPM'),
          value: '{{right_now.ampm}}',
        },
        {
          text: i18n.global.t('customVariables.day'),
          value: '{{right_now.day}}',
        },
        {
          text: i18n.global.t('customVariables.weekDayExtendedEnglish'),
          value: '{{right_now.day_of_week}}',
        },
        {
          text: i18n.global.t('customVariables.month'),
          value: '{{right_now.month}}',
        },
        {
          text: i18n.global.t('customVariables.monthExtendedEnglish'),
          value: '{{right_now.month_english}}',
        },
        {
          text: i18n.global.t('customVariables.year'),
          value: '{{right_now.year}}',
        },
        {
          text: i18n.global.t('customVariables.dateFormat1'),
          value: '{{right_now.middle_endian_date}}',
        },
        {
          text: i18n.global.t('customVariables.dateFormat2'),
          value: '{{right_now.little_endian_date}}',
        },
      ],
    },
    ...getEmailOptions(),
    {
      text: i18n.global.t('customVariables.membershipContacts'),
      menu: getMembershipOptions(),
    },
    {
      text: i18n.global.t('customVariables.shopify'),
      menu: getShopifyOptions(),
    },
    {
      text: i18n.global.t('customVariables.affiliateManager'),
      menu: getAffiliateOptions(),
    },
    {
      text: i18n.global.t('customVariables.orders'),
      menu: getOrdersOptions(),
    },
    {
      text: i18n.global.t('customVariables.invoice'),
      menu: getInvoiceOptions(),
    },
    {
      text: i18n.global.t('customVariables.proposals'),
      menu: getProposalDocumentOptions(),
    },
    { text: 'Receipt', menu: getReceiptOptions() },
    {
      text: i18n.global.t('customVariables.eCommerce'),
      menu: getEcommerceOptions(),
    },
    {
      text: i18n.global.t('customVariables.payment'),
      menu: getPaymentOptions(),
    },
  ]
  return [...tagOptions]
}

export function getReceiptOptions() {
  return [
    {
      text: 'Company',
      menu: [
        {
          text: 'Name',
          value: '{{receipt.company.name}}',
        },
        {
          text: 'Phone',
          value: '{{receipt.company.phone}}',
        },
        {
          text: 'Address',
          value: '{{receipt.company.address}}',
        },
        {
          text: 'City',
          value: '{{receipt.company.city}}',
        },
        {
          text: 'State',
          value: '{{receipt.company.state}}',
        },
        {
          text: 'Country',
          value: '{{receipt.company.country}}',
        },
        {
          text: 'Website',
          value: '{{receipt.company.website}}',
        },
        {
          text: 'Logo',
          value: '{{receipt.company.logo}}',
        },
      ],
    },
    {
      text: 'Customer',
      menu: [
        {
          text: 'Name',
          value: '{{receipt.customer.name}}',
        },
        {
          text: 'First Name',
          value: '{{receipt.customer.first_name}}',
        },
        {
          text: 'Last Name',
          value: '{{receipt.customer.last_name}}',
        },
        {
          text: 'Phone',
          value: '{{receipt.customer.phone}}',
        },
        {
          text: 'Email',
          value: '{{receipt.customer.email}}',
        },
        {
          text: 'Company',
          value: '{{receipt.customer.company}}',
        },
        {
          text: 'Address',
          value: '{{receipt.customer.address}}',
        },
        {
          text: 'City',
          value: '{{receipt.customer.city}}',
        },
        {
          text: 'State',
          value: '{{receipt.customer.state}}',
        },
        {
          text: 'Postal code',
          value: '{{receipt.customer.postal_code}}',
        },
      ],
    },
    {
      text: 'Number',
      value: '{{receipt.number}}',
    },
    {
      text: 'Date Paid',
      value: '{{receipt.date_paid}}',
    },
    {
      text: 'Currency Symbol',
      value: '{{receipt.currency_symbol}}',
    },
    {
      text: 'Currency Code',
      value: '{{receipt.currency_code}}',
    },
    {
      text: 'Sub Total',
      value: '{{receipt.sub_total}}',
    },
    {
      text: 'Discount Amount',
      value: '{{receipt.discount_amount}}',
    },
    {
      text: 'Tax Amount',
      value: '{{receipt.tax_amount}}',
    },
    {
      text: 'Total Amount',
      value: '{{receipt.total_amount}}',
    },
    {
      text: 'Title',
      value: '{{receipt.title}}',
    },
    {
      text: 'URL',
      value: '{{receipt.url}}',
    },
  ]
}

export function getEcommerceOptions() {
  return [
    {
      text: i18n.global.t('customVariables.checkoutPageUrl'),
      value: '{{ecommerce.checkout_page_url}}',
    },
    {
      text: i18n.global.t('customVariables.productListPage'),
      value: '{{ecommerce.product_list_page_url}}',
    },
  ]
}

export function getProposalDocumentOptions() {
  return [
    {
      text: i18n.global.t('common.name'),
      value: '{{document.name}}',
    },
    {
      text: i18n.global.t('common.url'),
      value: '{{document.url}}',
    },
    {
      text: i18n.global.t('common.type'),
      value: '{{document.type}}',
    },
    {
      text: i18n.global.t('customVariables.totalAmount'),
      value: '{{document.totalAmount}}',
    },
    {
      text: i18n.global.t('customVariables.currencyCode'),
      value: '{{document.currencyCode}}',
    },
    {
      text: i18n.global.t('customVariables.currencySymbol'),
      value: '{{document.currencySymbol}}',
    },
    {
      text: i18n.global.t('customVariables.recipient'),
      menu: [
        {
          text: i18n.global.t('customVariables.firstName'),
          value: '{{document.recipient.firstName}}',
        },
        {
          text: i18n.global.t('customVariables.lastName'),
          value: '{{document.recipient.lastName}}',
        },
        {
          text: i18n.global.t('customVariables.email'),
          value: '{{document.recipient.email}}',
        },
        {
          text: i18n.global.t('customVariables.phone'),
          value: '{{document.recipient.phoneNumber}}',
        },
        {
          text: i18n.global.t('customVariables.country'),
          value: '{{document.recipient.country}}',
        },
      ],
    },
  ]
}

export function getPaymentOptions() {
  return [
    {
      text: i18n.global.t('customVariables.paymentReceived'),
      menu: [
        {
          text: i18n.global.t('customVariables.source'),
          value: '{{payment.source}}',
        },
        {
          text: i18n.global.t('customVariables.currencySymbol'),
          value: '{{payment.currency_symbol}}',
        },
        {
          text: i18n.global.t('customVariables.currencyCode'),
          value: '{{payment.currency_code}}',
        },
        {
          text: i18n.global.t('customVariables.customer'),
          menu: [
            {
              text: i18n.global.t('customVariables.id'),
              value: '{{payment.customer.id}}',
            },
            {
              text: i18n.global.t('customVariables.firstName'),
              value: '{{payment.customer.first_name}}',
            },
            {
              text: i18n.global.t('customVariables.lastName'),
              value: '{{payment.customer.last_name}}',
            },
            {
              text: i18n.global.t('common.name'),
              value: '{{payment.customer.name}}',
            },
            {
              text: i18n.global.t('customVariables.email'),
              value: '{{payment.customer.email}}',
            },
            {
              text: i18n.global.t('customVariables.phone'),
              value: '{{payment.customer.phone}}',
            },
            {
              text: i18n.global.t('customVariables.fullAddress'),
              value: '{{payment.customer.address}}',
            },
            {
              text: i18n.global.t('customVariables.city'),
              value: '{{payment.customer.city}}',
            },
            {
              text: i18n.global.t('customVariables.state'),
              value: '{{payment.customer.state}}',
            },
            {
              text: i18n.global.t('customVariables.country'),
              value: '{{payment.customer.country}}',
            },
            {
              text: i18n.global.t('customVariables.postalCode'),
              value: '{{payment.customer.postal_code}}',
            },
          ],
        },
        {
          text: i18n.global.t('customVariables.invoice'),
          menu: [
            {
              text: i18n.global.t('common.name'),
              value: '{{payment.invoice.name}}',
            },
            {
              text: i18n.global.t('customVariables.number'),
              value: '{{payment.invoice.number}}',
            },
            {
              text: i18n.global.t('customVariables.issueDate'),
              value: '{{payment.invoice.issue_date}}',
            },
            {
              text: i18n.global.t('customVariables.dueDate'),
              value: '{{payment.invoice.due_date}}',
            },
            {
              text: i18n.global.t('common.url'),
              value: '{{payment.invoice.url}}',
            },
            {
              text: i18n.global.t('customVariables.recordedBy'),
              value: '{{payment.invoice.recorded_by}}',
            },
            {
              text: i18n.global.t('customVariables.amountDue'),
              value: '{{payment.invoice.amount_due}}',
            },
            {
              text: i18n.global.t('customVariables.amountPaid'),
              value: '{{payment.invoice.amount_paid}}',
            },
          ],
        },
        {
          text: i18n.global.t('customVariables.subTotal'),
          value: '{{payment.sub_total_amount}}',
        },
        {
          text: i18n.global.t('customVariables.discountAmount'),
          value: '{{payment.discount_amount}}',
        },
        {
          text: i18n.global.t('customVariables.couponCode'),
          value: '{{payment.coupon_code}}',
        },
        {
          text: i18n.global.t('customVariables.taxAmount'),
          value: '{{payment.tax_amount}}',
        },
        {
          text: i18n.global.t('customVariables.createdOn'),
          value: '{{payment.created_on}}',
        },
        {
          text: i18n.global.t('customVariables.totalAmount'),
          value: '{{payment.total_amount}}',
        },
        {
          text: i18n.global.t('customVariables.transactionId'),
          value: '{{payment.transaction_id}}',
        },
        {
          text: i18n.global.t('common.status'),
          value: '{{payment.payment_status}}',
        },
        {
          text: i18n.global.t('customVariables.gateway'),
          value: '{{payment.gateway}}',
        },
        {
          text: i18n.global.t('customVariables.cardLast4'),
          value: '{{payment.card.last4}}',
        },
        {
          text: i18n.global.t('customVariables.cardBrand'),
          value: '{{payment.card.brand}}',
        },
        {
          text: i18n.global.t('customVariables.method'),
          value: '{{payment.method}}',
        },
      ],
    },
    {
      text: i18n.global.t('customVariables.subscription'),
      menu: [
        {
          text: i18n.global.t('customVariables.source'),
          value: '{{subscription.source}}',
        },
        {
          text: i18n.global.t('customVariables.currencySymbol'),
          value: '{{subscription.currency_symbol}}',
        },
        {
          text: i18n.global.t('customVariables.currencyCode'),
          value: '{{subscription.currency_code}}',
        },
        {
          text: i18n.global.t('customVariables.subTotal'),
          value: '{{subscription.sub_total_amount}}',
        },
        {
          text: i18n.global.t('customVariables.discountAmount'),
          value: '{{subscription.discount_amount}}',
        },
        {
          text: i18n.global.t('customVariables.taxAmount'),
          value: '{{subscription.tax_amount}}',
        },
        {
          text: i18n.global.t('customVariables.totalAmount'),
          value: '{{subscription.total_amount}}',
        },
        {
          text: i18n.global.t('customVariables.createdOn'),
          value: '{{subscription.created_on}}',
        },
        {
          text: i18n.global.t('customVariables.couponCode'),
          value: '{{subscription.coupon_code}}',
        },
        {
          text: i18n.global.t('customVariables.subscriptionId'),
          value: '{{subscription.id}}',
        },
        {
          text: i18n.global.t('customVariables.subscriptionStatus'),
          value: '{{subscription.status}}',
        },
        {
          text: i18n.global.t('emailBuilder.productName'),
          value: '{{subscription.global_product.name}}',
        },
      ],
    },
    {
      text: i18n.global.t('customVariables.refund'),
      menu: [
        {
          text: i18n.global.t('customVariables.source'),
          value: '{{refund.transaction.entitySourceType}}',
        },
        {
          text: i18n.global.t('customVariables.currencySymbol'),
          value: '{{refund.currency_symbol}}',
        },
        {
          text: i18n.global.t('customVariables.currencyCode'),
          value: '{{refund.currency_code}}',
        },
        {
          text: i18n.global.t('customVariables.transactionId'),
          value: '{{refund.transaction.id}}',
        },
        {
          text: i18n.global.t('customVariables.refundId'),
          value: '{{refund.id}}',
        },
        {
          text: i18n.global.t('customVariables.refundAmount'),
          value: '{{refund.amount}}',
        },
        {
          text: i18n.global.t('customVariables.refundStatus'),
          value: '{{refund.status}}',
        },
        {
          text: i18n.global.t('customVariables.refundType'),
          value: '{{refund.transaction.status}}',
        },
      ],
    },
  ]
}
